import React from "react";

//느낌표 안내 아이콘
export const CautionIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 64 64">
			<path d="M31.999,63.67 C14.809,63.67 0.932,49.190 0.932,31.999 C0.932,14.809 14.809,0.932 31.999,0.932 C49.190,0.932 63.67,14.809 63.67,31.999 C63.67,49.190 49.190,63.67 31.999,63.67 ZM31.999,3.3 C16.51,3.3 3.3,16.52 3.3,31.999 C3.3,47.947 16.51,60.995 31.999,60.995 C48.50,60.995 60.995,47.947 60.995,31.999 C60.995,16.52 47.947,3.3 31.999,3.3 ZM29.964,43.944 L34.35,43.944 L34.35,48.51 L29.964,48.51 L29.964,43.944 ZM29.964,15.948 L34.35,15.948 L34.35,38.802 L29.964,38.802 L29.964,15.948 Z" />
		</svg>
	);
};

// 물음표 안내 아이콘
export const QuestionMarkIcon = () => {
	return (
		<svg
			width="15"
			height="15"
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M15.0785 7C15.7033 7 16.28 7.12444 16.7927 7.37333C17.3053 7.62222 17.7379 7.96 18.0983 8.37778C18.4507 8.78667 18.7071 9.26667 18.8593 9.80889C19.0114 10.36 19.0435 10.92 18.9394 11.5067C18.8112 12.1822 18.5869 12.7244 18.2505 13.1333C17.9221 13.5422 17.5857 13.9067 17.2412 14.2444C16.8968 14.5733 16.5924 14.92 16.3281 15.2667C16.0558 15.6133 15.9276 16.0756 15.9276 16.6356V18.9111H14.0453V16.6978C14.0453 15.9422 14.1814 15.3289 14.4458 14.8578C14.7181 14.3778 15.0225 13.96 15.3589 13.6044C15.6873 13.2489 16.0157 12.9022 16.3281 12.5822C16.6405 12.2533 16.8488 11.8622 16.9369 11.3911C16.9849 11.1067 16.9769 10.8311 16.9128 10.5378C16.8488 10.2533 16.7366 9.99556 16.5764 9.76445C16.4002 9.53333 16.1839 9.34667 15.9276 9.21333C15.6633 9.07111 15.3589 9 15.0225 9C14.2695 9 13.7169 9.24 13.3644 9.72C13.012 10.2 12.8598 10.8311 12.8918 11.6222H11.0095C10.9774 11.0356 11.0255 10.4667 11.1697 9.91556C11.3139 9.36445 11.5462 8.86667 11.8826 8.43111C12.227 8.01333 12.6595 7.66667 13.1882 7.40889C13.7169 7.15111 14.3496 7.01778 15.0946 7.01778L15.0785 7ZM16.1599 23H13.829V20.4578H16.1599V23Z" />
			<path d="M15 30C6.73 30 0 23.27 0 15C0 6.73 6.73 0 15 0C23.27 0 30 6.73 30 15C30 23.27 23.27 30 15 30ZM15 2.69C8.21 2.69 2.69 8.21 2.69 15C2.69 21.79 8.21 27.31 15 27.31C21.79 27.31 27.31 21.79 27.31 15C27.31 8.21 21.79 2.69 15 2.69V2.69Z" />
		</svg>
	);
};

// RoundArrowIcon 이동 버튼 아이콘
export const RoundArrowIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			viewBox="0 0 40 40"
			className="round-arrow-icon"
		>
			{/*<circle cx="20" cy="20" r="19.5"/>*/}
			<path
				d="M15.8,20l7.3-7.7c0.2-0.2,0.2-0.5,0-0.7c0,0,0,0,0,0c-0.2-0.2-0.4-0.1-0.6,0l-7.6,8c-0.2,0.2-0.2,0.5,0,0.7
l7.6,8c0,0,0,0,0,0c0.2,0.2,0.4,0.1,0.6,0c0.2-0.2,0.2-0.5,0-0.7L15.8,20z"
			/>
		</svg>
	);
};

// 검색 아이콘
export const SearchIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
			{/* <path fillRule="evenodd" d="m17.712 16.232-4.431-4.398a6.826 6.826 0 0 0 1.326-4.047c0-3.801-3.118-6.894-6.951-6.894C3.825.893.707 3.986.707 7.787c0 3.803 3.118 6.895 6.949 6.895a6.96 6.96 0 0 0 3.919-1.203l4.735 4.42 1.402-1.667zM2.745 7.787c0-2.686 2.203-4.873 4.912-4.873s4.912 2.187 4.912 4.873c0 2.687-2.203 4.874-4.912 4.874s-4.912-2.187-4.912-4.874z"/> */}

			<path
				fillRule="evenodd"
				d="m17.712 16.232-4.431-4.398a6.826 6.826 0 0 0 1.326-4.047c0-3.801-3.118-6.894-6.951-6.894C3.825.893.707 3.986.707 7.787c0 3.803 3.118 6.895 6.949 6.895a6.96 6.96 0 0 0 3.919-1.203l4.735 4.42 1.402-1.667zM2.745 7.787c0-2.686 2.203-4.873 4.912-4.873s4.912 2.187 4.912 4.873c0 2.687-2.203 4.874-4.912 4.874s-4.912-2.187-4.912-4.874z"
			/>
		</svg>
	);
};

// 두꺼운 체크 아이콘
export const ThickChkIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="15px">
			<path d="M19.151,1.239 C18.482,0.566 17.397,0.566 16.728,1.239 L7.657,10.357 L3.728,6.407 C3.58,5.734 1.974,5.734 1.303,6.407 C0.635,7.80 0.635,8.170 1.303,8.843 L6.445,14.11 C6.780,14.347 7.218,14.515 7.657,14.515 C8.95,14.515 8.535,14.347 8.868,14.11 L19.151,3.675 C19.820,3.2 19.820,1.912 19.151,1.239 Z" />
		</svg>
	);
};

// 얇은 체크 아이콘
export const ThinChkIcon = () => {
	return (
		<svg
			width="20"
			height="15"
			viewBox="0 0 20 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M19.6696 1.32205C19.2339 0.888052 18.5339 0.888052 18.0982 1.32205L7.03393 12.3331L1.89821 7.21605C1.4625 6.78205 0.7625 6.78205 0.326786 7.21605C-0.108929 7.65005 -0.108929 8.35005 0.326786 8.77705L6.25536 14.6711C6.46964 14.888 6.75536 14.993 7.04107 14.993C7.32679 14.993 7.6125 14.888 7.82679 14.6711L19.6696 2.89005C20.1054 2.45605 20.1054 1.75605 19.6696 1.32905V1.32205Z" />
		</svg>
	);
};

// 네비게이션 dot 아이콘
export const NavDotIcon = () => {
	return (
		<svg
			version="1.1"
			id="레이어_1"
			xmlns="http://www.w3.org/2000/svg"
			width="8px"
			height="8px"
			viewBox="0 0 8 8"
		>
			<path className="st0" d="M8,4c0,2.2-1.8,4-4,4S0,6.2,0,4s1.8-4,4-4S8,1.8,8,4z" />
		</svg>
	);
};

// 체크 아이콘
export const CheckIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" className="check-icon">
			<g id="prefix__그룹_2031" transform="translate(-928.286 -403.286)">
				<path
					id="prefix__패스_426"
					d="M10.3.736L3.916 8.025 0 4.58l.755-.853 3.058 2.682L9.46 0z"
					transform="translate(934.665 411.069)"
				></path>
			</g>
		</svg>
	);
};

// 라운드 체크박스 아이콘
export const RoundChkBoxIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px">
			<path d="M10.999,21.999 C4.933,21.999 0.0,17.65 0.0,10.999 C0.0,4.933 4.933,0.0 10.999,0.0 C17.65,0.0 21.999,4.933 21.999,10.999 C21.999,17.65 17.65,21.999 10.999,21.999 ZM10.999,1.144 C5.566,1.144 1.144,5.566 1.144,10.999 C1.144,16.433 5.566,20.854 10.999,20.854 C16.433,20.854 20.854,16.433 20.854,10.999 C20.854,5.566 16.433,1.144 10.999,1.144 ZM10.206,14.706 C10.11,14.901 9.755,14.999 9.499,14.999 C9.243,14.999 8.987,14.901 8.792,14.706 L5.792,11.706 C5.402,11.316 5.402,10.683 5.792,10.292 C6.183,9.901 6.816,9.901 7.206,10.292 L9.499,12.585 L14.792,7.292 C15.183,6.901 15.816,6.901 16.206,7.292 C16.597,7.683 16.597,8.316 16.206,8.706 L10.206,14.706 Z" />
		</svg>
	);
};

// 파일업로드 아이콘
export const UploadIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16">
			<path d="M5.654,3.933 L7.200,3.933 L7.200,11.14 C7.200,11.106 7.275,11.182 7.367,11.182 L8.623,11.182 C8.716,11.182 8.791,11.106 8.791,11.14 L8.791,3.933 L10.343,3.933 C10.483,3.933 10.560,3.771 10.474,3.662 L8.130,0.695 C8.73,0.622 7.967,0.609 7.894,0.666 C7.884,0.674 7.874,0.684 7.865,0.695 L5.521,3.660 C5.436,3.771 5.513,3.933 5.654,3.933 L5.654,3.933 ZM15.660,10.386 L14.404,10.386 C14.312,10.386 14.237,10.461 14.237,10.553 L14.237,13.777 L1.759,13.777 L1.759,10.553 C1.759,10.461 1.684,10.386 1.592,10.386 L0.336,10.386 C0.244,10.386 0.168,10.461 0.168,10.553 L0.168,14.698 C0.168,15.68 0.467,15.368 0.839,15.368 L15.157,15.368 C15.527,15.368 15.828,15.68 15.828,14.698 L15.828,10.553 C15.828,10.461 15.751,10.386 15.660,10.386 Z" />
		</svg>
	);
};

// 파일다운로드 아이콘
export const DownloadIcon = () => {
	return (
		<svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
			<path d="M5.75577 7.07141H7.23846V0.89462C7.23846 0.814263 7.30769 0.749977 7.4 0.749977H8.6C8.68654 0.749977 8.76154 0.814263 8.76154 0.89462V7.07141H10.25C10.3827 7.07141 10.4577 7.21069 10.3769 7.30712L8.12692 9.89462C8.075 9.95891 7.97115 9.96962 7.90192 9.92141C7.89038 9.91605 7.88462 9.90533 7.87308 9.89462L5.62885 7.30712C5.54808 7.21069 5.62308 7.07141 5.75577 7.07141ZM15.3385 9.2603H14.1327C14.0462 9.2603 13.9712 9.32458 13.9712 9.40494V12.2174H2.02308V9.40494C2.02308 9.32458 1.95385 9.2603 1.86154 9.2603H0.661538C0.575 9.2603 0.5 9.32458 0.5 9.40494V13.021C0.5 13.3424 0.788462 13.6049 1.14038 13.6049H14.8596C15.2173 13.6049 15.5 13.3424 15.5 13.021V9.40494C15.5 9.32458 15.425 9.2603 15.3385 9.2603Z" />
		</svg>
	);
};

// 파일링크 아이콘
export const FileLinkIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
			<path d="M16.2 0H5.18824C4.71102 0.000560444 4.25351 0.190383 3.91606 0.527827C3.57862 0.865271 3.3888 1.32278 3.38824 1.8V2.54118H1.8C1.32278 2.54174 0.865274 2.73156 0.52783 3.069C0.190386 3.40645 0.000560444 3.86396 0 4.34118V16.2C0.000560444 16.6772 0.190386 17.1347 0.52783 17.4722C0.865274 17.8096 1.32278 17.9994 1.8 18H13.6588C14.136 17.9994 14.5935 17.8096 14.931 17.4722C15.2684 17.1347 15.4583 16.6772 15.4588 16.2V14.6118H16.2C16.6772 14.6112 17.1347 14.4214 17.4722 14.0839C17.8096 13.7465 17.9994 13.289 18 12.8118V1.8C17.9994 1.32278 17.8096 0.865271 17.4722 0.527827C17.1347 0.190383 16.6772 0.000560444 16.2 0ZM14.4 16.2C14.4 16.3966 14.3219 16.5851 14.1829 16.7241C14.0439 16.8631 13.8554 16.9412 13.6588 16.9412H1.8C1.60343 16.9412 1.41491 16.8631 1.27591 16.7241C1.13692 16.5851 1.05882 16.3966 1.05882 16.2V4.34118C1.05882 4.1446 1.13692 3.95608 1.27591 3.81709C1.41491 3.67809 1.60343 3.6 1.8 3.6H13.6588C13.8554 3.6 14.0439 3.67809 14.1829 3.81709C14.3219 3.95608 14.4 4.1446 14.4 4.34118V16.2ZM16.9412 12.8118C16.9412 13.0083 16.8631 13.1969 16.7241 13.3359C16.5851 13.4749 16.3966 13.5529 16.2 13.5529H15.4588V4.34118C15.4583 3.86396 15.2684 3.40645 14.931 3.069C14.5935 2.73156 14.136 2.54174 13.6588 2.54118H4.44706V1.8C4.44706 1.60343 4.52515 1.41491 4.66415 1.27591C4.80315 1.13691 4.99166 1.05882 5.18824 1.05882H16.2C16.3966 1.05882 16.5851 1.13691 16.7241 1.27591C16.8631 1.41491 16.9412 1.60343 16.9412 1.8V12.8118Z" />
			<path d="M11.5175 5.94572C11.119 5.54391 10.5785 5.31509 10.0127 5.30873H9.98576C9.71232 5.30732 9.44131 5.36015 9.18843 5.46419C8.93554 5.56822 8.70581 5.72138 8.51252 5.9148L8.50997 5.91755L6.26337 8.25628C6.22619 8.29485 6.19519 8.33892 6.17146 8.38694C5.85099 8.79366 5.69452 9.30569 5.7329 9.82207C5.76897 10.3457 5.99406 10.8384 6.36628 11.2085C6.46586 11.3075 6.60069 11.3629 6.74112 11.3625C6.88155 11.3621 7.01607 11.306 7.11509 11.2064C7.2141 11.1068 7.2695 10.972 7.2691 10.8315C7.26871 10.6911 7.21255 10.5566 7.11297 10.4576C6.92231 10.2678 6.80715 10.0153 6.78896 9.74689C6.77812 9.60072 6.79882 9.45393 6.84964 9.31644C6.90046 9.17896 6.98022 9.054 7.08353 8.95002C7.11428 8.91906 7.14109 8.88442 7.16337 8.8469L9.26471 6.66042C9.67257 6.2568 10.347 6.27184 10.7693 6.69452C10.9749 6.89721 11.0926 7.17263 11.0969 7.46132C11.0998 7.59855 11.0749 7.73495 11.0237 7.86232C10.9726 7.98969 10.8962 8.1054 10.7992 8.2025L10.796 8.20588L9.98004 9.06988C9.93184 9.12035 9.8941 9.17985 9.86897 9.24495C9.84385 9.31006 9.83184 9.37949 9.83365 9.44926C9.83545 9.51902 9.85104 9.58774 9.8795 9.65146C9.90796 9.71518 9.94873 9.77265 9.99948 9.82055C10.0502 9.86845 10.11 9.90585 10.1752 9.93059C10.2405 9.95533 10.31 9.96692 10.3797 9.9647C10.4495 9.96248 10.5181 9.94649 10.5816 9.91765C10.6452 9.88881 10.7024 9.84769 10.75 9.79666L11.5547 8.94494C11.7503 8.74834 11.9043 8.51443 12.0076 8.25713C12.111 7.99982 12.1616 7.72437 12.1563 7.44713C12.1486 6.88222 11.9191 6.34299 11.5175 5.94572Z" />
			<path d="M8.66372 9.414C8.61489 9.36342 8.55649 9.32307 8.49191 9.29531C8.42732 9.26755 8.35786 9.25292 8.28757 9.25229C8.21727 9.25166 8.14755 9.26504 8.08248 9.29164C8.01741 9.31824 7.95829 9.35753 7.90857 9.40723C7.85885 9.45692 7.81951 9.51602 7.79288 9.58107C7.76624 9.64613 7.75283 9.71584 7.75342 9.78613C7.75401 9.85643 7.76859 9.9259 7.79632 9.9905C7.82405 10.0551 7.86436 10.1135 7.91491 10.1624C8.12028 10.3656 8.23783 10.6412 8.24231 10.93C8.24508 11.0654 8.22086 11.1999 8.17104 11.3258C8.12123 11.4517 8.04683 11.5664 7.95219 11.6632L5.77588 13.6387C5.76995 13.644 5.76423 13.6497 5.75788 13.6559C5.66077 13.7529 5.54506 13.8292 5.41769 13.8803C5.29032 13.9315 5.15392 13.9563 5.0167 13.9534C4.72803 13.9491 4.45259 13.8316 4.2497 13.6262C4.04958 13.4261 3.93564 13.1343 3.93713 12.8255C3.93861 12.5168 4.05148 12.2326 4.24651 12.0359C4.35578 11.93 4.72129 11.5759 4.91251 11.3849C5.01181 11.2856 5.0676 11.1509 5.0676 11.0105C5.0676 10.8701 5.01181 10.7354 4.91251 10.6361C4.81322 10.5368 4.67854 10.481 4.53811 10.481C4.39768 10.481 4.26301 10.5368 4.16372 10.6361C3.95449 10.8453 3.51106 11.2744 3.50725 11.2782L3.50555 11.2796L3.50131 11.2839C3.10849 11.6763 2.88148 12.2368 2.87852 12.8202C2.87555 13.4098 3.10256 13.9765 3.5011 14.375C3.89881 14.776 4.43805 15.0047 5.00273 15.012H5.03153C5.57983 15.0144 6.10672 14.7994 6.49673 14.414L8.67578 12.4359L8.68468 12.4274C8.68743 12.4249 8.69019 12.4223 8.69336 12.4189C8.89074 12.2222 9.04629 11.9876 9.15066 11.7292C9.25503 11.4709 9.30607 11.194 9.30071 10.9154C9.29321 10.3508 9.06449 9.81173 8.66372 9.414Z" />
		</svg>
	);
};

// doble arrow 아이콘
export const ArrowIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="8px" height="10px">
			<path d="M7.879,4.859 L4.693,8.848 C4.533,9.048 4.273,9.048 4.113,8.848 C3.954,8.648 3.954,8.323 4.113,8.123 L7.010,4.496 L4.113,0.869 C3.954,0.669 3.954,0.344 4.113,0.144 C4.273,-0.057 4.533,-0.057 4.693,0.144 L7.879,4.133 C8.039,4.333 8.039,4.658 7.879,4.859 ZM3.879,4.859 L0.693,8.848 C0.533,9.048 0.273,9.048 0.113,8.848 C-0.046,8.648 -0.046,8.323 0.113,8.123 L3.010,4.496 L0.113,0.869 C-0.046,0.669 -0.046,0.344 0.113,0.144 C0.273,-0.057 0.533,-0.057 0.693,0.144 L3.879,4.133 C4.039,4.333 4.039,4.658 3.879,4.859 Z" />
		</svg>
	);
};

// single arrow 아이콘
export const SingleArrowIcon = () => {
	return (
		<svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.91563 3.7813L0.488402 0.0900154C0.375911 -0.0300045 0.193425 -0.0300045 0.0834336 0.0900154C-0.0265579 0.210035 -0.0290575 0.407402 0.0834336 0.527421L3.30818 4L0.0859334 7.47258C-0.0265579 7.5926 -0.0265579 7.78997 0.0859334 7.90999C0.198425 8.03001 0.38091 8.03001 0.490901 7.90999L3.91563 4.2187C4.02812 4.09868 4.02812 3.90132 3.91563 3.7813Z"
				fill="#2B2B2B"
			/>
		</svg>
	);
};

// Pagination 이동 버튼 아이콘
export const PaginationIcon = () => {
	return (
		<svg
			width="6"
			height="10"
			viewBox="0 0 6 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M1.52633 4.98547L5.87007 9.32296C5.90965 9.35817 5.94159 9.40115 5.96391 9.44919C5.98624 9.49723 5.99847 9.54935 5.99987 9.60231C6.00126 9.65527 5.99179 9.70792 5.97202 9.75707C5.95225 9.80622 5.92262 9.85082 5.88495 9.88807C5.84727 9.92531 5.80235 9.95443 5.75298 9.97363C5.70361 9.99284 5.65083 10.0017 5.59789 9.99972C5.54495 9.99773 5.49298 9.98487 5.44519 9.962C5.39741 9.93912 5.35483 9.90669 5.32007 9.86671L0.70758 5.25425C0.636203 5.18176 0.596191 5.08411 0.596191 4.98238C0.596191 4.88065 0.636203 4.78296 0.70758 4.71047L5.32007 0.098019C5.39365 0.0325636 5.48938 -0.00245676 5.58782 0.000134154C5.68627 0.00272506 5.78003 0.0427076 5.85006 0.111943C5.92009 0.181178 5.96113 0.274498 5.96485 0.372905C5.96856 0.471313 5.93468 0.567446 5.87007 0.641764L1.52633 4.98547Z" />
		</svg>
	);
};

// Pagination 이동 버튼 아이콘
export const PaginationEdgeIcon = () => {
	return (
		<svg
			width="9"
			height="10"
			viewBox="0 0 9 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.999 0L0.999 4.444V0H0V9.999H0.999V5.555L8.999 9.999V0ZM7.999 8.3L2.58 4.999L7.999 1.699V8.3Z"
			/>
		</svg>
	);
};

// 펼치기 버튼 아이콘
export const CollapseArrow = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="8"
			viewBox="0 0 16 8"
			className="round-arrow-icon"
		>
			<path
				d="M0.8,0.1L8,7l7.2-6.9c0.2-0.2,0.5-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6c0,0,0,0,0,0
	L8.3,7.9C8.1,8,7.9,8,7.7,7.9L0.1,0.7C0,0.6,0,0.3,0.1,0.1c0,0,0,0,0,0C0.3,0,0.6,0,0.8,0.1z"
			/>
		</svg>
	);
};

// 플러스 아이콘
export const PlusIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="29.995"
			height="29.996"
			viewBox="0 0 29.995 29.996"
			className="plus-icon"
		>
			<path
				id="prefix__패스_201"
				d="M29.512 15.5h-14v14a.5.5 0 0 1-1 0v-14h-14a.5.5 0 0 1 0-1h14V.5a.5.5 0 0 1 1 0v14h14a.5.5 0 0 1 0 1z"
				transform="translate(-.016 -.002)"
			/>
		</svg>
	);
};

// 인증메일 아이콘
export const AuthEmailIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142 140">
			<rect x="21.2" y="19.7" className="st0" width="2" height="47.1" />
			<rect x="21.7" y="19.7" className="st0" width="98.2" height="2" />
			<rect x="118.4" y="19.7" className="st0" width="2" height="47.5" />
			<rect
				x="85"
				y="76.8"
				transform="matrix(0.8051 -0.5931 0.5931 0.8051 -25.8345 77.0011)"
				className="st0"
				width="38.5"
				height="2"
			/>
			<path className="st1" d="M70.8,73.5" />
			<path className="st1" d="M90.2,90.6" />
			<path className="st1" d="M52.6,90.5" />
			<path className="st1" d="M71.8,74" />
			<rect
				x="36.9"
				y="57.7"
				transform="matrix(0.5829 -0.8125 0.8125 0.5829 -47.206 63.1451)"
				className="st0"
				width="2"
				height="39.6"
			/>
			<path
				className="st0"
				d="M23,68.1l-20.8-14c-0.4-0.3-0.6-0.7-0.6-1.2s0.2-0.9,0.6-1.2l21-15.2L23,68.1z M4,52.9l17,11.5l0.1-23.9L4,52.9
	z"
			/>
			<path
				className="st0"
				d="M98.4,21.6H44.2L71.5-0.1L98.4,21.6z M49.9,19.6h42.8L71.5,2.5L49.9,19.6z"
			/>
			<path
				className="st0"
				d="M5.6,139.9c-2.1,0-3.9-1.3-4.6-3.2c-0.7-2-0.1-4.1,1.5-5.4l67.1-55.7c1.1-0.9,2.8-0.9,3.9,0l65.6,55.6
	c1.6,1.3,2.1,3.5,1.4,5.4c-0.7,2-2.5,3.2-4.6,3.2L5.6,139.9C5.7,139.9,5.7,139.9,5.6,139.9z M70.9,77.1L3.8,132.8
	c-1.2,1-1.2,2.3-0.9,3.2c0.3,0.9,1.2,1.9,2.7,1.9c0,0,0,0,0,0l130.3-0.1c1.5,0,2.4-1,2.7-1.9c0.3-0.9,0.3-2.2-0.8-3.2L72.2,77.1
	C71.8,76.8,71.2,76.8,70.9,77.1z"
			/>
			<path
				className="st0"
				d="M118.6,68.4l-0.2-31.6l21,14.9c0.3,0.2,0.5,0.6,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1L118.6,68.4z M120.5,40.6
	l0.1,23.9l16.8-11.8L120.5,40.6z"
			/>
			<path
				className="st0"
				d="M139.5,134.1c-0.6,0-0.9-0.5-1.2-0.9c-0.1-0.2-0.3-0.4-0.4-0.5L88.7,91c-0.4-0.3-0.6-0.9-0.6-1.4s0.3-1,0.7-1.4
	l49.2-36.1c0.5-0.4,1.2-0.4,1.8-0.1c0.6,0.3,1,0.9,1,1.6l-0.3,79.4c0,0.8-0.6,1.1-0.8,1.1C139.7,134.1,139.6,134.1,139.5,134.1z
	 M90.3,89.7l48.3,41l0.3-76.6L90.3,89.7z M90,89.8L90,89.8C90,89.8,90,89.8,90,89.8L90,89.8z"
			/>
			<path
				className="st0"
				d="M0.8,135.4l0.1-82c0-0.5,0.3-1,0.8-1.3c0.5-0.2,1-0.2,1.5,0.1L56,89.2L0.8,135.4z M3,54.4l-0.1,76.6l49.8-41.7
	L3,54.4z"
			/>
		</svg>
	);
};

// 둥근 마이너스(삭제) 아이콘
export const RoundMinusIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 16">
			<path d="M7.5,1C3.9,1,1,3.9,1,7.5S3.9,14,7.5,14S14,11.1,14,7.5S11.1,1,7.5,1 M7.5,0C11.6,0,15,3.4,15,7.5S11.6,15,7.5,15S0,11.6,0,7.5S3.4,0,7.5,0z"></path>
			<path d="M4.5,6.5h6c0.6,0,1,0.4,1,1s-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1S3.9,6.5,4.5,6.5z"></path>
		</svg>
	);
};

// 삼각형 경고 아이콘
export const TriangleCautionIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="53" height="46">
			<path d="M26.5 3.007l23.902 41.486H2.598L26.5 3.007m0-3.006L0 45.996h53L26.5.001zm-1.573 37.184c0-1.059.734-1.825 1.733-1.825 1.057 0 1.733.766 1.733 1.825 0 1.031-.676 1.826-1.733 1.826-1.029 0-1.733-.795-1.733-1.826zm.734-4.209l-.412-14.128h2.82l-.411 14.128h-1.997z"></path>
		</svg>
	);
};

// 하트 아이콘
export const HeartIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="17px" height="16px">
			<path d="M8.650,15.291 C8.578,15.291 8.505,15.291 8.432,15.219 L7.923,14.931 C5.377,13.347 0.650,10.395 0.650,5.643 C0.650,3.51 2.687,0.891 5.232,0.891 C6.541,0.891 7.777,1.467 8.650,2.475 C9.523,1.467 10.759,0.891 12.68,0.891 C14.614,0.891 16.650,3.51 16.650,5.643 C16.650,10.395 11.923,13.347 9.377,14.931 L8.868,15.219 C8.796,15.291 8.723,15.291 8.650,15.291 Z" />
		</svg>
	);
};

// 영상재생 아이콘
export const IconVideo = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="9px" height="12px">
			<path d="M8.998,5.999 L-0.000,0.000 L-0.000,11.998 L8.998,5.999 " />
		</svg>
	);
};

// 다운로드 아이콘
export const IconDownload = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="15px"
			height="16px"
			viewBox="0 0 365.262 342.979"
		>
			<path
				d="M365.262,239.782v78.85c0,13.425-11.129,24.347-24.807,24.347H24.806
    C11.128,342.979,0,332.057,0,318.632v-78.85c0-6.352,5.148-11.5,11.5-11.5c6.351,0,11.5,5.148,11.5,11.5v78.85
    c0,0.637,0.742,1.347,1.806,1.347h315.649c1.064,0,1.807-0.71,1.807-1.347v-78.85c0-6.352,5.148-11.5,11.5-11.5
    S365.262,233.431,365.262,239.782z M174.498,253.645c2.157,2.157,5.082,3.368,8.132,3.368c3.049,0,5.975-1.211,8.131-3.368
    l98.427-98.426c4.491-4.491,4.491-11.772,0-16.264s-11.772-4.49-16.264,0l-78.794,78.793V11.5c0-6.351-5.148-11.5-11.5-11.5
    s-11.5,5.149-11.5,11.5v206.25l-78.794-78.794c-4.492-4.491-11.772-4.49-16.264,0c-4.491,4.491-4.491,11.772,0,16.264
    L174.498,253.645z"
			/>
		</svg>
	);
};

// 프린트 아이콘
export const PrintIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21">
			<path
				id="prefix__패스_101"
				d="M623.9 635.22h-3.135v-4.387a.53.53 0 0 0-.524-.533h-10.478a.53.53 0 0 0-.524.533v4.387H606.1a2.124 2.124 0 0 0-2.1 2.141v7.557a2.127 2.127 0 0 0 2.1 2.144h1.5a.533.533 0 0 0 0-1.067h-1.5a1.068 1.068 0 0 1-1.056-1.077v-7.557a1.066 1.066 0 0 1 1.056-1.075h17.8a1.067 1.067 0 0 1 1.056 1.075v7.557A1.068 1.068 0 0 1 623.9 646h-1.5a.533.533 0 0 0 0 1.067h1.5a2.127 2.127 0 0 0 2.1-2.144v-7.557a2.12 2.12 0 0 0-2.1-2.146zm-13.613-3.853h9.43v3.853h-9.43zm8.533 17.033a.527.527 0 0 1-.524.533h-6.59a.533.533 0 0 1 0-1.067h6.588a.531.531 0 0 1 .526.534zm-7.638-2.683a.53.53 0 0 1 .524-.533h6.588a.533.533 0 0 1 0 1.067h-6.588a.529.529 0 0 1-.524-.53zm10.5-2.2a.533.533 0 0 0 0-1.067h-13.365a.533.533 0 0 0 0 1.067h.652v7.243a.529.529 0 0 0 .524.533h11.015a.529.529 0 0 0 .524-.533v-7.243zm-1.7 6.707h-9.967v-6.709h9.967zm1.158-11.536a.533.533 0 0 1 0-1.067h1.81a.533.533 0 0 1 0 1.067z"
				transform="translate(-604 -630.3)"
			/>
		</svg>
	);
};

// pdf 아이콘
export const PdfIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20.957"
			height="20.957"
			viewBox="0 0 20.957 20.957"
		>
			<path
				id="prefix__패스_100"
				d="M1479.426 1194.891c1.624 0 4.075-2.169 5.866-5.822a34.746 34.746 0 0 1 5.994-1.617c1.462 1.124 3.076 2.2 3.858 2.2 2.165 0 2.62-1.252 2.62-2.3 0-2.064-2.359-2.064-3.493-2.064a20.629 20.629 0 0 0-2.533.311 25.38 25.38 0 0 1-2.089-1.8c-.665-.665-1.258-1.31-1.773-1.924a19.555 19.555 0 0 0 1.155-4.444c0-2.9-1.047-3.493-2.62-3.493-1.195 0-2.62.621-2.62 3.576 0 1.3.714 2.885 2.128 4.723-.346 1.057-.753 2.275-1.21 3.649-.22.659-.459 1.27-.711 1.834-.205.091-.4.184-.6.281-.694.347-1.354.659-1.965.949-2.788 1.32-4.63 2.193-4.63 3.917.003 1.249 1.363 2.024 2.623 2.024zm14.844-7.859c1.29 0 1.656.126 1.746.318 0 .392 0 .555-.81.56a6.44 6.44 0 0 1-1.467-.837c.247-.027.429-.041.531-.041zm-5.857-2c.164.164.57.532 1.11.994-1.076.234-2.221.525-3.316.872q.082-.228.159-.46c.324-.972.616-1.845.876-2.632q.543.594 1.172 1.224zm-2.875-7.519c0-1.83.568-1.83.873-1.83.617 0 .873 0 .873 1.746a14.006 14.006 0 0 1-.695 2.727 5.366 5.366 0 0 1-1.051-2.646zm-3.354 13.014l.346-.163c-1.312 1.9-2.609 2.783-3.1 2.783a1.38 1.38 0 0 1-.873-.281c-.005-.621 1.843-1.496 3.627-2.342z"
				transform="translate(-1476.806 -1173.934)"
			/>
		</svg>
	);
};

// 엑셀 아이콘
export const ExcelIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
			<g>
				<path d="M18.9972 2.25162H12.6017V0.964972C12.6022 0.823634 12.571 0.683962 12.5105 0.556262C12.4499 0.428562 12.3614 0.31605 12.2517 0.227007C12.1444 0.136177 12.0184 0.0703761 11.8826 0.0343737C11.7467 -0.00162866 11.6046 -0.00690095 11.4665 0.0188984L0.813664 1.91105C0.589799 1.94731 0.386365 2.06278 0.240499 2.23643C0.094634 2.41008 0.0159603 2.63035 0.0188789 2.85712V16.9442C0.0152248 17.1682 0.0912741 17.3862 0.233339 17.5595C0.375404 17.7327 0.574329 17.8499 0.794724 17.8902L11.4475 20.0094H11.6367C11.8589 20.0072 12.0733 19.9268 12.2422 19.7824C12.3537 19.6943 12.444 19.5822 12.5062 19.4544C12.5684 19.3267 12.6011 19.1865 12.6017 19.0444V17.5875H19.0161C19.267 17.5875 19.5076 17.4878 19.685 17.3104C19.8624 17.133 19.9622 16.8923 19.9622 16.6414V3.21663C19.9648 3.0892 19.9415 2.96254 19.8939 2.8443C19.8464 2.72606 19.7754 2.61863 19.6853 2.5285C19.5951 2.43837 19.4878 2.3674 19.3695 2.31981C19.2513 2.27223 19.1246 2.24904 18.9972 2.25162ZM11.6556 19.0539L0.993363 16.9158V2.80983L11.6651 0.91768V18.9971L11.6556 19.0539ZM19.0634 16.613H12.6017V14.4371H13.6424V13.6802H12.6017V11.4096H13.6424V10.6528H12.6017V8.76061H13.6424V8.00376H12.6017V6.11162H13.6424V5.35477H12.6017V3.17875H19.0351L19.0634 16.613Z" />
				<path d="M7.43614 6.41443L6.19679 8.36334L4.95743 6.41443H2.93283L5.18449 9.96221L2.93283 13.51H4.95743L6.19679 11.5611L7.43614 13.51H9.46074L7.20908 9.96221L9.46074 6.41443H7.43614Z" />
				<path d="M17.4078 5.37366H14.3803V6.13052H17.4078V5.37366Z" />
				<path d="M17.4078 8.02271H14.3803V8.77956H17.4078V8.02271Z" />
				<path d="M17.4078 10.6718H14.3803V11.4286H17.4078V10.6718Z" />
				<path d="M17.4078 13.6991H14.3803V14.456H17.4078V13.6991Z" />
			</g>
		</svg>
	);
};

// 탑버튼 화살표 아이콘
export const TopBtnIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="23">
			<path
				fillRule="evenodd"
				d="M0 1V0h19.999v1H0zm9.35 3.162c.027-.03.055-.057.086.628.354-1.011.89-.973 1.197-.628l8.811 10.548c.12-.504.022-.297-.159-.297h-2.151c-.034 0-.241-.052-.321-.142L11.2 7.735v14.587c0 .114-.294.207-.411.207H9.196c.594 0-.212-.093-.212-.207V7.735l-5.812 6.536c.728.09-.199.142-.321.142H.701a.213.213 0 0 1-.139-.051c-.088-.074-.097-.205-.021.348L9.35 4.162z"
			/>
		</svg>
	);
};

//지구 아이콘
export const EarthIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
			<path d="M12.000,24.000 C5.377,24.000 -0.000,18.623 -0.000,12.000 C-0.000,5.383 5.367,0.011 11.981,-0.000 L12.000,-0.000 L12.020,-0.000 C18.634,0.011 24.000,5.383 24.000,12.000 C24.000,18.623 18.624,24.000 12.000,24.000 ZM22.249,16.000 L16.726,16.000 C16.300,18.985 15.405,21.402 14.241,22.771 C17.910,22.011 20.912,19.421 22.249,16.000 ZM15.843,9.000 L8.158,9.000 C7.963,10.800 7.933,12.927 8.158,15.000 L15.843,15.000 C16.039,13.189 16.067,11.070 15.843,9.000 ZM12.000,23.000 C13.472,23.000 15.075,20.266 15.714,16.000 L8.287,16.000 C8.926,20.266 10.529,23.000 12.000,23.000 ZM9.760,22.771 C8.596,21.402 7.701,18.985 7.275,16.000 L1.751,16.000 C3.089,19.421 6.091,22.011 9.760,22.771 ZM1.416,15.000 L7.152,15.000 C6.964,13.186 6.937,11.075 7.152,9.000 L1.416,9.000 C1.085,10.166 0.675,12.389 1.416,15.000 ZM1.751,8.000 L7.275,8.000 C7.701,5.015 8.596,2.597 9.760,1.229 C6.091,1.989 3.089,4.579 1.751,8.000 ZM12.000,1.000 C10.529,1.000 8.926,3.734 8.287,8.000 L15.714,8.000 C15.075,3.734 13.472,1.000 12.000,1.000 ZM14.241,1.229 C15.405,2.597 16.300,5.015 16.726,8.000 L22.249,8.000 C20.912,4.579 17.910,1.989 14.241,1.229 ZM16.849,9.000 C16.911,9.592 17.157,12.019 16.849,15.000 L22.585,15.000 C23.326,12.388 22.916,10.165 22.585,9.000 L16.849,9.000 Z"></path>
		</svg>
	);
};

//이동 아이콘
export const MoveIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="6"
			viewBox="0 0 14 6"
			className=""
		>
			<rect className="st0" width="2" height="2" />
			<rect x="4" className="st0" width="2" height="2" />
			<rect x="8" className="st0" width="2" height="2" />
			<rect x="12" className="st0" width="2" height="2" />
			<rect y="4" className="st0" width="2" height="2" />
			<rect x="4" y="4" className="st0" width="2" height="2" />
			<rect x="8" y="4" className="st0" width="2" height="2" />
			<rect x="12" y="4" className="st0" width="2" height="2" />
		</svg>
	);
};

//복사 아이콘
export const CopyIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="22"
			viewBox="0 0 19 22"
			className=""
		>
			<polygon className="st0" points="16,0 0,0 0,2 0,19 2,19 2,2 16,2 " />
			<rect x="9" y="8" className="st0" width="5" height="1" />
			<rect x="9" y="12" className="st0" width="5" height="1" />
			<rect x="9" y="16" className="st0" width="5" height="1" />
			<path className="st0" d="M17,4H6H4v2v14v1v1h15v-1v-1V6V4H17z M17,20H6V6h11V20z" />
		</svg>
	);
};

//휴지통 아이콘
export const TrashIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="22"
			viewBox="0 0 19 22"
			className=""
		>
			<path
				className="st0"
				d="M16.1,22H2.8c-1,0-1.9-0.8-1.9-1.8V4.6H0V2.8h5.7V1.4C5.7,0.6,6.4,0,7.1,0h4.8c0.8,0,1.4,0.6,1.4,1.4v1.4H19
v1.8h-1v15.6C18,21.2,17.2,22,16.1,22z M16.1,4.6H2.8v15.1c0,0.3,0.2,0.5,0.5,0.5h12.4c0.3,0,0.5-0.2,0.5-0.5V4.6z M7.6,8.3
c0-0.6-0.4-0.9-0.9-0.9s-1,0.4-1,0.9v8.3c0,0.6,0.4,0.9,1,0.9s0.9-0.4,0.9-0.9V8.3z M13.3,8.3c0-0.6-0.4-0.9-0.9-0.9
c-0.6,0-1,0.4-1,0.9v8.3c0,0.6,0.4,0.9,1,0.9c0.6,0,0.9-0.4,0.9-0.9V8.3z M11.4,1.8H7.6v0.9h3.8V1.8z"
			/>
		</svg>
	);
};

//휴지통 아이콘
export const CategoryIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="34"
			height="34"
			viewBox="0 0 34 34"
			className=""
		>
			<path
				className="st0"
				d="M9.8,19.3c0-0.3,0-0.6-0.1-0.8c-0.1-0.2-0.1-0.4-0.3-0.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.6-0.1
            l-0.5,0v-1.4l0.4,0c0.2,0,0.4,0,0.6-0.1s0.3-0.1,0.4-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.5,0.1-0.8v-3.2c0-0.5,0.1-1,0.2-1.3
            c0.2-0.4,0.4-0.7,0.6-0.9c0.3-0.2,0.6-0.4,0.9-0.5c0.3-0.1,0.7-0.2,1.1-0.2c0.2,0,0.4,0,0.6,0.1c0.2,0,0.5,0.1,0.7,0.1v1.2h-0.3
            c-0.4,0-0.7,0-0.9,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.3,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.5V14c0,0.4,0,0.7-0.1,1
            c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.2-0.4,0.3-0.7,0.4v0.2c0.3,0.1,0.5,0.2,0.7,0.4s0.3,0.4,0.4,0.6
            c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3,0.1,0.6,0.1,1v3.1c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.6,0.2
            c0.2,0,0.5,0.1,0.9,0.1H14v1.2c-0.2,0.1-0.5,0.1-0.7,0.2c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.6-0.3-0.9-0.5
            c-0.3-0.2-0.5-0.5-0.6-0.9c-0.2-0.4-0.2-0.8-0.2-1.4V19.3z"
			/>
			<path
				className="st0"
				d="M20.4,24.1c0.4,0,0.6,0,0.9-0.1c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.3-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.5V20
            c0-0.4,0-0.7,0.1-1s0.1-0.6,0.2-0.8c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.2,0.4-0.3,0.7-0.4v-0.2c-0.3-0.1-0.5-0.2-0.7-0.4
            c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3-0.1-0.6-0.1-1v-3.1c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.3-0.3
            c-0.1-0.1-0.3-0.1-0.6-0.2c-0.2,0-0.5-0.1-0.9-0.1H20V8.7c0.2-0.1,0.5-0.1,0.7-0.1c0.2,0,0.4-0.1,0.6-0.1c0.4,0,0.8,0.1,1.1,0.2
            c0.3,0.1,0.7,0.3,0.9,0.5c0.3,0.2,0.5,0.5,0.6,0.9c0.2,0.4,0.2,0.8,0.2,1.3v3.2c0,0.3,0,0.6,0.1,0.8c0.1,0.2,0.1,0.4,0.3,0.5
            c0.1,0.1,0.3,0.2,0.4,0.3s0.4,0.1,0.6,0.1l0.4,0v1.4l-0.5,0c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.1-0.4,0.3
            c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.5-0.1,0.8v3.2c0,0.5-0.1,1-0.2,1.4c-0.2,0.4-0.4,0.7-0.6,0.9c-0.3,0.2-0.6,0.4-0.9,0.5
            c-0.3,0.1-0.7,0.2-1.1,0.2c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.5-0.1-0.7-0.2v-1.2H20.4z"
			/>
		</svg>
	);
};

// 클립 아이콘
export const ClipIcon = () => {
	return (
		<svg
			width="11"
			height="13"
			viewBox="0 0 11 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.99115 1.09815C8.66697 0.753018 8.27543 0.477971 7.84072 0.28993C7.40602 0.101889 6.93737 0.00488281 6.46368 0.00488281C5.99 0.00488281 5.52135 0.101889 5.08664 0.28993C4.65194 0.477971 4.2604 0.753018 3.93621 1.09815L0.0800667 5.15146C0.066776 5.16447 0.0562085 5.18001 0.0490003 5.19716C0.0417921 5.2143 0.0380859 5.23267 0.0380859 5.25127C0.0380859 5.26986 0.0417921 5.28823 0.0490003 5.30537C0.0562085 5.32252 0.066776 5.33806 0.0800667 5.35107L0.61952 5.92007C0.630721 5.93458 0.645109 5.94636 0.661562 5.95444C0.678015 5.96252 0.696095 5.96675 0.714427 5.96675C0.732759 5.96675 0.750854 5.96252 0.767307 5.95444C0.783759 5.94636 0.798133 5.93458 0.809333 5.92007L4.66548 1.92673C4.89296 1.6776 5.16992 1.47865 5.47868 1.3425C5.78743 1.20635 6.1212 1.13605 6.45868 1.13605C6.79616 1.13605 7.12993 1.20635 7.43869 1.3425C7.74745 1.47865 8.02441 1.6776 8.25189 1.92673C8.73483 2.43217 9.00333 3.10476 9.00114 3.8036C9.00179 4.50512 8.73369 5.18028 8.25189 5.69047L4.32582 9.8236L3.68646 10.4925C3.54741 10.6387 3.38006 10.7551 3.19458 10.8346C3.0091 10.9142 2.80937 10.9553 2.60754 10.9553C2.4057 10.9553 2.20597 10.9142 2.02049 10.8346C1.83502 10.7551 1.66767 10.6387 1.52862 10.4925C1.23998 10.1838 1.07943 9.77695 1.07943 9.35441C1.07943 8.93187 1.23998 8.52507 1.52862 8.21629L5.42471 4.12314C5.47258 4.07327 5.52994 4.03346 5.59341 4.00603C5.65689 3.9786 5.7252 3.96407 5.79435 3.96337C5.8635 3.96407 5.93181 3.9786 5.99528 4.00603C6.05875 4.03346 6.11611 4.07327 6.16398 4.12314C6.21359 4.17484 6.25239 4.23592 6.27812 4.30277C6.30385 4.36962 6.316 4.44091 6.31384 4.51251C6.31158 4.65294 6.25832 4.78777 6.16398 4.89188L2.96718 8.23628C2.95826 8.26896 2.95826 8.30341 2.96718 8.33609C2.95575 8.36839 2.95575 8.4036 2.96718 8.4359L3.51663 9.01501C3.54247 9.03887 3.57636 9.05206 3.61154 9.05206C3.64672 9.05206 3.68061 9.03887 3.70645 9.01501L6.89325 5.66062C7.18834 5.34912 7.35281 4.93645 7.35281 4.50751C7.35281 4.07857 7.18834 3.66589 6.89325 3.3544C6.75208 3.20293 6.58123 3.08212 6.39131 2.99953C6.20139 2.91693 5.99648 2.87437 5.78935 2.87437C5.58223 2.87437 5.37732 2.91693 5.1874 2.99953C4.99748 3.08212 4.82662 3.20293 4.68546 3.3544L4.31584 3.75376L0.789349 7.44756C0.308386 7.96621 0.0411651 8.64729 0.0411651 9.35441C0.0411651 10.0615 0.308386 10.7426 0.789349 11.2613C1.02119 11.5101 1.30184 11.7085 1.6138 11.8442C1.92575 11.9798 2.26232 12.0499 2.60254 12.0499C2.94276 12.0499 3.27933 11.9798 3.59128 11.8442C3.90323 11.7085 4.18388 11.5101 4.41573 11.2613L8.99115 6.45921C9.65955 5.73618 10.0307 4.78795 10.0307 3.8036C10.0307 2.81926 9.65955 1.87115 8.99115 1.14812V1.09815Z"
				fill="#666666"
			/>
		</svg>
	);
};

// 휴지통 아이콘
export const FileDeleteIcon = () => {
	return (
		<svg width="8" height="10" viewBox="0 0 8 10" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.13 1.51001V0.720093C6.07094 0.517218 5.94912 0.338214 5.78204 0.208862C5.61496 0.0795107 5.4112 0.00636693 5.2 0H3.2C2.98879 0.00636693 2.78504 0.0795107 2.61797 0.208862C2.45089 0.338214 2.32907 0.517218 2.27 0.720093V1.51001H0V2.09998H0.470001L1.05 9.09998C1.08616 9.33843 1.20729 9.55584 1.39105 9.71204C1.57482 9.86824 1.80884 9.9528 2.05 9.95007H6C6.24116 9.9528 6.47519 9.86824 6.65895 9.71204C6.84271 9.55584 6.96384 9.33843 7 9.09998L7.58 2.09998H8V1.51001H6.13ZM2.75999 1.51001V0.849976C2.78001 0.772461 2.8253 0.703928 2.88869 0.655029C2.95207 0.606131 3.02995 0.57976 3.11 0.580078H5.11C5.1905 0.577953 5.26927 0.603648 5.33302 0.652832C5.39678 0.702016 5.44163 0.771577 5.46001 0.849976V1.51001H2.75999ZM6.97 2.09998L6.39 9.09998C6.38237 9.18661 6.34185 9.26705 6.27675 9.32471C6.21165 9.38237 6.12691 9.41293 6.03999 9.41003H2C1.91308 9.41293 1.82836 9.38237 1.76326 9.32471C1.69816 9.26705 1.65762 9.18661 1.64999 9.09998L1.07001 2.09998H6.97Z" />
		</svg>
	);
};

// 라운드 추가심사 아이콘
export const RoundCopyIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			enableBackground="new 0 0 16 16"
			xmlSpace="preserve"
			width="16"
			height="16"
		>
			<g>
				<rect x="3" y="3" width="5" height="1" />
				<path d="M11,5V0h-1H1H0v13h1h4v3h5h1h5v-5v-1V5H11z M5,12H1V1h9v4H5v1H3v1h2v2H3v1h2v1V12z M13,11h-2v2h-1v-2H8v-1 h2V8h1v2h2V11z" />
			</g>
		</svg>
	);
};

// 비밀번호 숨기기 아이콘
export const EyeHiddenIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12.313" width="16" height="12.313">
			<path
				d="M13.068,0l-2.229,2.094C9.992,1.808,9.048,1.627,8.011,1.627C2.964,1.627,0,5.999,0,5.999
	s1.285,1.97,3.431,3.429L1.49,11.367l0.943,0.944L14.014,0.943L13.068,0z M9.059,3.856C6.866,2.887,4.604,5.13,5.549,7.333
	l-1.15,1.139c-1.21-0.772-2.15-1.77-2.707-2.443c0.995-1.1,3.211-3.064,6.319-3.064c0.617,0,1.196,0.079,1.739,0.21L9.059,3.856z
	 M7.137,8.815l3.394-3.331C11.208,7.559,9.193,9.534,7.137,8.815z M16,5.999c0,0-2.835,4.97-7.989,4.97
	c-0.92,0-1.775-0.193-2.568-0.49L6.519,9.42c0.477,0.129,0.973,0.215,1.492,0.215c3.193,0,5.402-2.355,6.336-3.579
	c-0.486-0.549-1.306-1.329-2.394-1.971l0.993-0.975C14.936,4.38,16,5.999,16,5.999z"
			/>
		</svg>
	);
};

// 비밀번호 보기 아이콘
export const EyeShowIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12.313" width="16" height="12.313">
			<path
				d="M8.012,2.99c3.166,0,5.375,2.008,6.336,3.091c-0.936,1.225-3.144,3.576-6.336,3.576
	c-2.949,0-5.289-2.357-6.321-3.605C2.687,4.953,4.902,2.99,8.012,2.99z M8.012,1.656C2.964,1.656,0,6.024,0,6.024
	s3.223,4.965,8.012,4.965c5.153,0,7.988-4.965,7.988-4.965S13.141,1.656,8.012,1.656z M8,3.656c-1.473,0-2.667,1.193-2.667,2.667
	S6.527,8.99,8,8.99c1.473,0,2.667-1.193,2.667-2.667S9.473,3.656,8,3.656z"
			/>
		</svg>
	);
};

export const SortTop = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="9px"
			height="5px"
			viewBox="0 0 9 5"
			className="icon-sort-top"
		>
			<path d="M8.986,5.006 L-0.008,4.923 L4.602,-0.004 L8.986,5.006 Z" />
		</svg>
	);
};

export const SortBottom = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="9px"
			height="5px"
			viewBox="0 0 9 5"
			className="icon-sort-bottom"
		>
			<path d="M0.014,-0.006 L9.008,0.077 L4.398,5.004 L0.014,-0.006 Z" />
		</svg>
	);
};

export const ApplicantIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="31"
			height="31"
			viewBox="0 0 31 31"
			fill={"#fff"}
		>
			<g>
				<path
					className="st0"
					d="M18.2,17.8c1-0.8,1.7-2.1,1.7-3.5c0-2.4-2-4.4-4.4-4.4s-4.4,2-4.4,4.4c0,1.4,0.6,2.6,1.7,3.5
		c-2,1.2-2.6,3.5-2.8,5.3c0,0.4,0.2,0.7,0.6,0.8c0,0,0.1,0,0.1,0c0.3,0,0.6-0.3,0.7-0.6c0.3-2.8,1.3-4.3,3.2-4.7
		c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.2-0.6-0.5-0.7c-1.3-0.4-2.1-1.6-2.1-2.9c0-1.7,1.4-3,3-3c1.7,0,3,1.4,3,3c0,1.3-0.9,2.5-2.1,2.9
		c-0.3,0.1-0.5,0.4-0.5,0.7c0,0.3,0.2,0.6,0.5,0.6c1.9,0.4,2.9,1.8,3.2,4.7c0,0.4,0.4,0.6,0.8,0.6c0.4,0,0.6-0.4,0.6-0.8
		C20.8,21.3,20.2,19,18.2,17.8z"
				/>
				<path
					className="st0"
					d="M24,15.3c1-0.8,1.7-2.1,1.7-3.5c0-2.4-2-4.4-4.4-4.4c-1.2,0-2.4,0.5-3.2,1.4c-0.3,0.3-0.2,0.7,0,1
		c0.3,0.3,0.7,0.2,1,0c0.6-0.6,1.4-1,2.2-1c1.7,0,3,1.4,3,3c0,1.3-0.9,2.5-2.1,2.9c-0.3,0.1-0.5,0.4-0.5,0.7c0,0.3,0.2,0.6,0.5,0.6
		c1.9,0.4,2.9,1.8,3.2,4.7c0,0.3,0.3,0.6,0.7,0.6c0,0,0.1,0,0.1,0c0.4,0,0.6-0.4,0.6-0.8C26.6,18.8,26.1,16.4,24,15.3z"
				/>
				<path
					className="st0"
					d="M9.7,8.8c0.8,0,1.7,0.4,2.2,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1c-0.8-0.9-2-1.4-3.2-1.4
		c-2.4,0-4.4,2-4.4,4.4c0,1.4,0.6,2.6,1.7,3.5c-2,1.2-2.6,3.5-2.8,5.3c0,0.4,0.2,0.7,0.6,0.8c0,0,0.1,0,0.1,0c0.3,0,0.6-0.3,0.7-0.6
		c0.3-2.8,1.3-4.3,3.2-4.7c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.2-0.6-0.5-0.7c-1.3-0.4-2.1-1.6-2.1-2.9C6.7,10.1,8,8.8,9.7,8.8z"
				/>
				<path
					className="st0"
					d="M15.5,0C7,0,0,7,0,15.5S7,31,15.5,31S31,24,31,15.5S24,0,15.5,0z M15.5,29.7c-7.9,0-14.2-6.4-14.2-14.2
		S7.6,1.3,15.5,1.3s14.2,6.4,14.2,14.2S23.4,29.7,15.5,29.7z"
				/>
			</g>
		</svg>
	);
};

export const ShareIcon = () => {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="#6B44FF"
			xmlns="http://www.w3.org/2000/svg"
		>
			<ellipse cx="2.41522" cy="5.89599" rx="2.41522" ry="2.35839" />
			<ellipse cx="9.58416" cy="9.64159" rx="2.41522" ry="2.35839" />
			<ellipse cx="9.58416" cy="2.35839" rx="2.41522" ry="2.35839" />
			<path
				d="M2.18945 6.03467C5.4735 4.22119 7.31473 3.20444 10.5988 1.39096"
				stroke="#6B44FF"
			/>
			<path
				d="M2.18945 5.63208C5.4735 7.44556 7.31473 8.46231 10.5988 10.2758"
				stroke="#6B44FF"
			/>
		</svg>
	);
};

// 포트폴리오 연결아이콘
export const PortfolioConnectIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
			<path d="M25.3,3.9l2.8,2.9c0.6,0.7,0.6,1.7,0,2.4l-4.3,4.4c-0.4,0.4-1.1,0.6-1.6,0.4l-2.5,2.5l0.1,0.1 c2,1.4,4.7,1.2,6.5-0.5l4.3-4.4c2-2,2-5.2,0-7.2l-2.8-2.9c-2-2-5.1-2-7.1,0l-4.3,4.4c-1.7,1.8-2,4.5-0.5,6.6l0.1,0.1l2.5-2.5 c-0.2-0.6-0.1-1.2,0.4-1.7L23,3.9C23.6,3.3,24.7,3.3,25.3,3.9z"></path>
			<path d="M17.7,18.5l-2.5,2.5c0.2,0.6,0.1,1.2-0.4,1.7l-4.3,4.4c-0.6,0.7-1.7,0.7-2.3,0l-2.8-2.9 c-0.6-0.7-0.6-1.7,0-2.4l4.3-4.4c0.4-0.4,1.1-0.6,1.6-0.4l2.5-2.5l-0.1-0.1c-2-1.4-4.7-1.2-6.5,0.5l-4.3,4.4c-2,2-2,5.2,0,7.2 l2.8,2.9c2,2,5.1,2,7.1,0l4.3-4.4C18.9,23.4,19.1,20.7,17.7,18.5L17.7,18.5z"></path>
			<path d="M7.8,9.2c0.3,0.3,0.8,0.3,1.1,0.1c0.3-0.3,0.3-0.8-0.1-1.1L5,4.3C4.7,4,4.2,4,4,4.2C3.7,4.5,3.7,5,4,5.3 L7.8,9.2z"></path>
			<path d="M6.4,12.4c0.1-0.1,0.2-0.3,0.2-0.5c0-0.4-0.4-0.8-0.8-0.8l-5.1-0.3c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.4,0.8,0.8,0.8l5.1,0.3C6.1,12.6,6.3,12.5,6.4,12.4z"></path>
			<path d="M11.5,6.9c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5L11.9,1c0-0.4-0.4-0.8-0.8-0.8 c-0.4,0-0.7,0.3-0.7,0.7l0.3,5.2C10.7,6.5,11.1,6.9,11.5,6.9z"></path>
			<path d="M23.5,23c-0.3-0.3-0.8-0.3-1.1-0.1c-0.3,0.3-0.3,0.8,0.1,1.1l3.8,3.9c0.3,0.3,0.8,0.3,1.1,0.1 c0.3-0.3,0.3-0.8-0.1-1.1L23.5,23z"></path>
			<path d="M19.8,25.3c-0.4,0-0.7,0.3-0.7,0.7l0.3,5.2c0,0.4,0.4,0.8,0.8,0.8c0.2,0,0.4-0.1,0.5-0.2s0.2-0.3,0.2-0.5 l-0.3-5.2C20.6,25.7,20.2,25.3,19.8,25.3z"></path>
			<path d="M30.5,19.9l-5.1-0.3c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.4,0.8,0.8,0.8l5.1,0.3c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.2-0.3,0.2-0.5C31.2,20.3,30.9,19.9,30.5,19.9z"></path>
		</svg>
	);
};

// 포트폴리오 연결신청아이콘
export const PortfolioApplyIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
			<path d="M7.2,10.2c0.5-0.5,1.1-0.9,1.7-1.3c3.4-1.9,7.7-0.9,9.9,2.4l-2.6,2.6c-0.8-1.7-2.6-2.7-4.5-2.3c-0.7,0.2-1.4,0.5-1.9,1l-5,5 c-1.5,1.5-1.5,4,0,5.5s4,1.5,5.5,0l1.5-1.5c1.4,0.6,2.9,0.8,4.4,0.7l-3.4,3.4c-2.9,2.9-7.7,2.9-10.6,0s-2.9-7.7,0-10.6 C2.2,15.2,7.2,10.2,7.2,10.2z M15.2,2.2l-3.4,3.4c1.5-0.1,3,0.1,4.4,0.7l1.5-1.5c1.5-1.5,4-1.5,5.5,0c1.5,1.5,1.5,4,0,5.5l-5,5 c-1.5,1.5-4,1.5-5.5,0c-0.4-0.4-0.7-0.8-0.8-1.2l-2.6,2.6c0.3,0.4,0.6,0.8,0.9,1.1c0.9,0.9,2.2,1.7,3.5,2c1.8,0.4,3.7,0.2,5.4-0.7 c0.6-0.3,1.2-0.8,1.7-1.3l5-5c2.9-2.9,2.9-7.7,0-10.6C22.9-0.7,18.1-0.7,15.2,2.2z"></path>
		</svg>
	);
};

// 필터 아이콘
export const FilterIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18">
			<g clipPath="url(#clip0_809_1236)">
				<path
					d="M0.875 3.46256H2.45219C2.62808 3.91515 2.93568 4.30399 3.33487 4.57836C3.73406 4.85273 4.2063 4.9999 4.69 5.00064C5.17407 5.00034 5.64679 4.85339 6.04641 4.57899C6.44604 4.30459 6.75397 3.9155 6.93 3.46256H20.125C20.3571 3.46256 20.5796 3.36996 20.7437 3.20513C20.9078 3.04031 21 2.81675 21 2.58365C21 2.35055 20.9078 2.127 20.7437 1.96217C20.5796 1.79734 20.3571 1.70475 20.125 1.70475H6.93C6.75397 1.2518 6.44604 0.862711 6.04641 0.588313C5.64679 0.313915 5.17407 0.166964 4.69 0.166656C4.2063 0.167405 3.73406 0.314564 3.33487 0.588933C2.93568 0.863303 2.62808 1.25215 2.45219 1.70475H0.875C0.642936 1.70475 0.420375 1.79734 0.256281 1.96217C0.0921866 2.127 0 2.35055 0 2.58365C0 2.81675 0.0921866 3.04031 0.256281 3.20513C0.420375 3.36996 0.642936 3.46256 0.875 3.46256ZM4.03375 2.58365C4.03375 2.40883 4.10289 2.24116 4.22596 2.11754C4.34903 1.99392 4.51595 1.92447 4.69 1.92447C4.86405 1.92447 5.03097 1.99392 5.15404 2.11754C5.27711 2.24116 5.34625 2.40883 5.34625 2.58365C5.34625 2.75848 5.27711 2.92614 5.15404 3.04976C5.03097 3.17338 4.86405 3.24283 4.69 3.24283C4.60382 3.24283 4.51848 3.22578 4.43886 3.19265C4.35924 3.15953 4.2869 3.11097 4.22596 3.04976C4.16502 2.98855 4.11669 2.91588 4.08371 2.83591C4.05073 2.75593 4.03375 2.67022 4.03375 2.58365Z"
					fill="#6b44ff"
				/>
				<path
					d="M20.125 8.28555H18.4013C18.2252 7.83261 17.9173 7.44352 17.5177 7.16912C17.118 6.89473 16.6453 6.74777 16.1613 6.74747C15.6772 6.74777 15.2045 6.89473 14.8048 7.16912C14.4052 7.44352 14.0973 7.83261 13.9213 8.28555H0.875C0.642936 8.28555 0.420375 8.37815 0.256281 8.54298C0.0921866 8.7078 0 8.93136 0 9.16446C0 9.39756 0.0921866 9.62111 0.256281 9.78594C0.420375 9.95077 0.642936 10.0434 0.875 10.0434H13.9213C14.0973 10.4963 14.4052 10.8854 14.8048 11.1598C15.2045 11.4342 15.6772 11.5811 16.1613 11.5815C16.6453 11.5811 17.118 11.4342 17.5177 11.1598C17.9173 10.8854 18.2252 10.4963 18.4013 10.0434H20.125C20.3571 10.0434 20.5796 9.95077 20.7437 9.78594C20.9078 9.62111 21 9.39756 21 9.16446C21 8.93136 20.9078 8.7078 20.7437 8.54298C20.5796 8.37815 20.3571 8.28555 20.125 8.28555ZM16.8175 9.16446C16.8175 9.33928 16.7484 9.50695 16.6253 9.63057C16.5022 9.75419 16.3353 9.82364 16.1613 9.82364C15.9872 9.82364 15.8203 9.75419 15.6972 9.63057C15.5741 9.50695 15.505 9.33928 15.505 9.16446C15.505 8.98963 15.5741 8.82197 15.6972 8.69835C15.8203 8.57473 15.9872 8.50528 16.1613 8.50528C16.3353 8.50528 16.5022 8.57473 16.6253 8.69835C16.7484 8.82197 16.8175 8.98963 16.8175 9.16446Z"
					fill="#6b44ff"
				/>
				<path
					d="M20.125 14.8686H10.2594C10.0834 14.4156 9.77542 14.0265 9.3758 13.7521C8.97618 13.4777 8.50345 13.3308 8.01938 13.3305C7.53531 13.3308 7.06258 13.4777 6.66296 13.7521C6.26334 14.0265 5.9554 14.4156 5.77937 14.8686H0.875C0.642936 14.8686 0.420375 14.9612 0.256281 15.126C0.0921866 15.2908 0 15.5144 0 15.7475C0 15.9806 0.0921866 16.2041 0.256281 16.3689C0.420375 16.5338 0.642936 16.6264 0.875 16.6264H5.77937C5.9554 17.0793 6.26334 17.4684 6.66296 17.7428C7.06258 18.0172 7.53531 18.1642 8.01938 18.1645C8.50345 18.1642 8.97618 18.0172 9.3758 17.7428C9.77542 17.4684 10.0834 17.0793 10.2594 16.6264H20.125C20.3571 16.6264 20.5796 16.5338 20.7437 16.3689C20.9078 16.2041 21 15.9806 21 15.7475C21 15.5144 20.9078 15.2908 20.7437 15.126C20.5796 14.9612 20.3571 14.8686 20.125 14.8686ZM8.67563 15.7475C8.67563 15.9223 8.60648 16.09 8.48341 16.2136C8.36034 16.3372 8.19343 16.4066 8.01938 16.4066C7.84534 16.4066 7.67841 16.3372 7.55534 16.2136C7.43227 16.09 7.36313 15.9223 7.36313 15.7475C7.36313 15.5726 7.43227 15.405 7.55534 15.2814C7.67841 15.1577 7.84534 15.0883 8.01938 15.0883C8.19343 15.0883 8.36034 15.1577 8.48341 15.2814C8.60648 15.405 8.67563 15.5726 8.67563 15.7475Z"
					fill="#6b44ff"
				/>
			</g>
			<defs>
				<clipPath id="clip0_809_1236">
					<rect width="21" height="18" fill="#6b44ff" transform="translate(0 0.166656)" />
				</clipPath>
			</defs>
		</svg>
	);
};

// 포트폴리오 empty 아이콘
export const PortfolioEmptyIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
			<rect width="80" height="80" rx="40" fill="#1A181A" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M54.0199 54H25.9801C23.7857 54 22 52.2942 22 50.1973V29.8038C22 27.7069 23.7857 26 25.9801 26H54.0199C56.2143 26 58 27.7069 58 29.8038V50.1973C58 52.2942 56.2143 54 54.0199 54ZM55.488 29.8038C55.488 29.0296 54.8289 28.4003 54.0199 28.4003H25.9801C25.1699 28.4003 24.5109 29.0296 24.5109 29.8038V32.6244H55.488V29.8038ZM55.488 34.5448H24.5109V50.1973C24.5109 50.9704 25.1699 51.6008 25.9801 51.6008H54.0199C54.8289 51.6008 55.488 50.9704 55.488 50.1973V34.5448ZM51.3544 48.3398C50.7993 48.3398 50.3493 47.9094 50.3493 47.379V39.3881C50.3493 38.8577 50.7993 38.4273 51.3544 38.4273C51.9095 38.4273 52.3594 38.8577 52.3594 39.3881V47.379C52.3594 47.9094 51.9095 48.3398 51.3544 48.3398ZM47.157 48.3488C46.6019 48.3488 46.152 47.9195 46.152 47.3891V41.3951C46.152 40.8647 46.6019 40.4343 47.157 40.4343C47.7121 40.4343 48.1621 40.8647 48.1621 41.3951V47.3891C48.1621 47.9195 47.7121 48.3488 47.157 48.3488ZM42.9585 48.3499C42.4034 48.3499 41.9534 47.9195 41.9534 47.3891V43.3931C41.9534 42.8627 42.4034 42.4334 42.9585 42.4334C43.5135 42.4334 43.9635 42.8627 43.9635 43.3931V47.3891C43.9635 47.9195 43.5135 48.3499 42.9585 48.3499ZM33.1524 49.0151C29.829 49.0151 27.1245 46.4305 27.1245 43.2549C27.1245 40.0792 29.829 37.4946 33.1524 37.4946C36.4758 37.4946 39.1804 40.0792 39.1804 43.2549C39.1804 46.4305 36.4758 49.0151 33.1524 49.0151ZM34.1575 39.5522V42.2952H37.0285C36.6636 40.9524 35.5617 39.9005 34.1575 39.5522ZM33.1524 44.2157C32.5973 44.2157 32.1474 43.7853 32.1474 43.2549V39.5522C30.4195 39.9815 29.1334 41.4715 29.1334 43.2549C29.1334 45.372 30.9368 47.0947 33.1524 47.0947C35.0196 47.0947 36.5786 45.8664 37.0285 44.2157H33.1524Z"
				fill="white"
			/>
		</svg>
	);
};

// 프로필 아이콘
export const ProfileIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 7.5C9.38071 7.5 10.5 6.38071 10.5 5C10.5 3.61929 9.38071 2.5 8 2.5C6.61929 2.5 5.5 3.61929 5.5 5C5.5 6.38071 6.61929 7.5 8 7.5Z"
				stroke="#A9A9A9"
			/>
			<path
				d="M13.5 14V14C13.5 11.2386 11.2614 9 8.5 9H7.5C4.73858 9 2.5 11.2386 2.5 14V14"
				stroke="#A9A9A9"
			/>
		</svg>
	);
};

// 수정 아이콘(연필)
export const EditIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
			<path d="M12.862 0.467992L12.2256 1.10452C11.6016 1.72851 11.6016 2.74019 12.2256 3.36418L14.6362 5.77502C15.2601 6.39901 16.2717 6.39901 16.8956 5.77502L17.5321 5.1385C18.156 4.51451 18.156 3.50282 17.5321 2.87883L15.1215 0.467992C14.4975 -0.155997 13.4859 -0.155997 12.862 0.467992Z" />
			<path d="M10.1194 3.5668C10.0181 3.46552 9.8606 3.46552 9.77059 3.5668L1.23097 12.1185C1.23097 12.1185 1.17472 12.1973 1.16347 12.2423L0.00459944 17.6997C-0.029154 17.8797 0.128362 18.0372 0.297129 17.9922L5.76519 16.8445C5.76519 16.8445 5.8552 16.8107 5.88895 16.777L14.4286 8.2365C14.5298 8.13523 14.5298 7.97769 14.4286 7.88768L10.1081 3.5668H10.1194Z" />
		</svg>
	);
};
// 없음 "-" 아이콘
export const NothingIcon = () => {
	return (
		<svg
			width="12"
			height="2"
			viewBox="0 0 12 2"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<line x1="1" y1="1" x2="11" y2="1" stroke="#A8A8A8" />
		</svg>
	);
};

//두꺼운 느낌표 안내 아이콘
export const CautionThickIcon = () => {
	return (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M7.5 15C3.34821 15 0 11.6518 0 7.5C0 3.34821 3.34821 0 7.5 0C11.6518 0.0669643 15 3.41518 15 7.5C15 11.5848 11.6518 15 7.5 15ZM7.5 1.40625C4.08482 1.40625 1.33929 4.15179 1.33929 7.56696C1.33929 10.9821 4.08482 13.7277 7.5 13.7277C10.9152 13.7277 13.6607 10.9821 13.6607 7.56696C13.6607 4.15179 10.9152 1.40625 7.5 1.40625Z" />
			<path d="M7.50009 8.90618C7.0983 8.90618 6.83044 8.63832 6.83044 8.23654V3.54904C6.83044 3.14725 7.0983 2.87939 7.50009 2.87939C7.90187 2.87939 8.16973 3.14725 8.16973 3.54904V8.23654C8.16973 8.63832 7.90187 8.90618 7.50009 8.90618Z" />
			<path d="M7.49987 11.7189C7.98065 11.7189 8.3704 11.3291 8.3704 10.8483C8.3704 10.3675 7.98065 9.97778 7.49987 9.97778C7.01909 9.97778 6.62933 10.3675 6.62933 10.8483C6.62933 11.3291 7.01909 11.7189 7.49987 11.7189Z" />
		</svg>
	);
};
